import React from "react";
import ReactDOMServer from "react-dom/server";

export const getVacancyContractHouseRulesHtml = () => {
  return ReactDOMServer.renderToString(<VacancyContractHouseRules />);
};

const VacancyContractHouseRules = () => {
  return (
    <div className="value-html">
      <h3 style={{ textAlign: "center" }}>
        <strong>Hausordnung</strong>
      </h3>
      <p style={{ textAlign: "justify" }}>
        Die Hausordnung enthält Rechte und Pflichten der Hausbewohner und regelt
        das Zusammenleben im Haus. Die Hausordnung gilt für alle Bewohner des
        Hauses.
      </p>
      <h3 style={{ textAlign: "center" }}>
        <strong>§ 1 Vermeidung von Ruhestörungen</strong>
      </h3>
      <p style={{ textAlign: "justify" }}>
        Der Hausfrieden in einem Mehrfamilienhaus ist auch bei guter
        Schalldämmung vom rücksichtsvollen Verhalten der Bewohner abhängig. Alle
        Bewohner des Hauses verpflichten sich:
      </p>
      <ol>
        <li style={{ textAlign: "justify" }}>
          Türen und Fenster geräuschlos zu schließen und nicht zuzuschlagen.
        </li>
        <li style={{ textAlign: "justify" }}>
          bei der Benutzung von Tonübertragungs- und Tonwiedergabegeräten stets
          Zimmerlautstärke einzuhalten.
        </li>
        <li style={{ textAlign: "justify" }}>
          Arbeitsmaschinen (Waschmaschinen, Geschirrspülmaschinen etc.)
          schalldämmend aufzustellen und zu betreiben.
        </li>
        <li style={{ textAlign: "justify" }}>
          ruhestörende Haus- und Gartenarbeiten nur werktags (Montag bis
          Sonnabend) von 8.00- 12.00 Uhr und von 15.00- 18.00 Uhr auszuführen.
          An Sonn- und Feiertagen ist jede mit Lärm verbundene Tätigkeit zu
          unterlassen.
        </li>
        <li style={{ textAlign: "justify" }}>
          Musikinstrumente nicht während der Mittagsruhe von 12.00- 15.00 Uhr
          und nicht von 19.00- 8.00 Uhr zu spielen.
        </li>
        <li style={{ textAlign: "justify" }}>
          darauf Einfluss zu nehmen, dass Kinder die Ruhezeiten einhalten und
          sich in die Gemeinschaft einfügen.
        </li>
        <li style={{ textAlign: "justify" }}>
          die Nachtruhe von 22.00 bis 7.00 Uhr einzuhalten.
        </li>
        <li style={{ textAlign: "justify" }}>
          bei der Durchführung von Feiern alle Mitbewohner rechtzeitig vorher zu
          informieren.
        </li>
      </ol>
      <h3 style={{ textAlign: "center" }}>
        <strong>§ 2 Sicherheit</strong>
      </h3>
      <ol>
        <li style={{ textAlign: "justify" }}>
          Haus- und Hofeingänge, Treppen und Flure sind als Fluchtwege
          grundsätzlich freizuhalten. Kinderwagen und Fahrräder sind in den
          Gemeinschaftsräumen (soweit vorhanden) abzustellen. Anderenfalls
          erfolgt die Unterbringung in den jeweiligen Privatkellern. Gleiches
          gilt für Kinderspielzeug, überflüssige Gegenstände und Möbel. Das
          Abstellen von Gegenständen, insbesondere von Krafträdern, Mopeds und
          Fahrrädern auf dem Hof, in der Garagenauffahrt, in den Gängen des
          Kellers oder im Treppenhaus, ist nicht gestattet. Für Unfälle oder
          Beschädigungen haften die Zuwiderhandelnden, für Kinder deren Eltern
          im Rahmen der gesetzlichen Vorschriften. Die Mitnahme von Krafträdern,
          Mopeds und Fahrrädern in die Wohnung ist unzulässig.
        </li>
        <li style={{ textAlign: "justify" }}>
          Haus-, Keller- und Hoftüren sind geschlossen zu halten jedoch nicht
          abzuschließen!
        </li>
        <li style={{ textAlign: "justify" }}>
          In der kalten Jahreszeit sind Kellerfenster und Treppenhausfenster in
          der Regel geschlossen zu halten; alle Fenster sind bei Regen und
          Unwetter zu schließen.
        </li>
        <li style={{ textAlign: "justify" }}>
          In den Speicherräumen (Keller, Bodenkammern, Abstellräume etc.) dürfen
          keine feuergefährlichen, leichtentzündlichen Stoffe und Gegenstände
          aufbewahrt werden. Darüber hinaus müssen abgestellte Gegenstände so
          aufgestellt werden, dass die Speicher, insbesondere alle Ecken und
          Winkel, leicht übersichtlich und zugänglich sind.
        </li>
        <li style={{ textAlign: "justify" }}>
          Das Grillen mit Holzkohle auf den Balkonen und Terrassen ist nicht
          gestattet.
        </li>
        <li style={{ textAlign: "justify" }}>
          Das Rauchen in gemeinschaftlich genutzten Räumen des Hauses ist nicht
          gestattet. Beim Rauchen auf Balkonen, Terrassen und an geöffneten
          Fenstern ist auf Nachbarbewohner Rücksicht zu nehmen.
        </li>
        <li style={{ textAlign: "justify" }}>
          Auf dem Gelände des Mietobjektes gilt die Straßenverkehrsordnung. Es
          ist grundsätzlich Schrittgeschwindigkeit einzuhalten. Reparaturen und
          Wartungsarbeiten auf dem Gelände des Mietobjektes sind nicht
          gestattet.
        </li>
      </ol>
      <h3 style={{ textAlign: "center" }}>
        <strong>§ 3 Reinigung</strong>
      </h3>
      <ol>
        <li style={{ textAlign: "justify" }}>
          Ist hinsichtlich der Treppenreinigung keine besondere Vereinbarung
          getroffen, wie die Übernahme durch den Vermieter, sind die Treppen und
          Zugänge zu den einzelnen Wohnungen durch die Bewohner je nach
          Beschaffenheit sachgemäß zu pflegen sowie wöchentlich einmal gründlich
          einschließlich der Geländer zu reinigen. Sind mehrere Parteien in
          einem Stockwerk, so haben sie mit der Treppenreinigung wöchentlich zu
          wechseln. Die Treppenhausfenster sind monatlich einmal zu putzen, die
          Mieter reinigen im Wechsel monatlich einmal die Haustür.
        </li>
        <li style={{ textAlign: "justify" }}>
          Stellt der Vermieter bzw. Hausmeister eine starke Verschmutzung durch
          die Nichteinhaltung der wöchentlichen Reinigung fest, so kann der
          Vermieter nach vorheriger Mahnung, die Reinigung auf Kosten des
          Mieters ausführen lassen.
        </li>
        <li style={{ textAlign: "justify" }}>
          Lässt sich eine außergewöhnliche Verschmutzung aus einem besonderen
          Grund ausnahmsweise nicht vermeiden, so ist es selbstverständlich,
          dass derjenige, der die Verschmutzung verursacht hat, diese
          unverzüglich beseitigt. Dies gilt auch für eventuelle Beschädigungen.
        </li>
        <li style={{ textAlign: "justify" }}>
          Abfälle dürfen nur in (<strong>nicht neben</strong>) die hierzu
          bestimmten Mülltonnen oder Container geleert werden, dabei ist auf
          konsequente Mülltrennung zu achten. Sondermüll und Sperrmüll gehören
          nicht in die Mülltonne. Sie sind nach der gemeindlichen Satzung
          gesondert zu entsorgen.
        </li>
        <li style={{ textAlign: "justify" }}>
          Balkonkästen und Blumenbretter sind sicher zu verankern. Beim Reinigen
          der Balkone und Fensterbretter und beim Gießen der Pflanzen ist darauf
          zu achten, dass kein Wasser an der Fassade herunterläuft und die
          darunter wohnenden Mieter nicht durch Tropfwasser belästigt werden.
        </li>
        <li style={{ textAlign: "justify" }}>
          Klopfen, Ausschütteln oder Reinigen von Betten, Matratzen, Decken,
          Kleidungsstücken, Schuhen usw. ist in den Treppenhäusern und Fluren
          sowie aus den Fenstern und über den Brüstungen der Balkone untersagt.
          Auf den Balkonen sind diese Tätigkeiten nur gestattet, wenn eine
          Belästigung von Nachbarn ausgeschlossen ist. Auf den
          Balkonen/Terrassen und Loggien darf Wäsche nur so aufgehängt werden,
          dass sie von außen nicht sichtbar ist.
        </li>
        <li style={{ textAlign: "justify" }}>
          Das Reinigen der Wäsche kann durch moderne Haushaltswaschmaschinen,
          die ordentlich installiert sind, in den Wohnungen vorgenommen werden.
          Soweit vorhanden, stehen gemeinschaftliche Wasch- /Trockenflächen zur
          Verfügung. Die Benutzungszeiten regeln die Bewohner einvernehmlich,
          falls notwendig, der Hausmeister.
        </li>
      </ol>
      <h3 style={{ textAlign: "center" }}>
        <strong>§ 4 Lüften</strong>
      </h3>
      <p style={{ textAlign: "justify" }}>
        Es ist notwendig, die Wohnungen – auch in der kalten Jahreszeit -
        ausgiebig zu lüften und ordentlich und sachgemäß zu beheizen, damit
        Schäden durch Schwitzwasserbildung und Schimmel vermieden werden. Dies
        geschieht durch kurzes, vollständiges Öffnen der Fenster zum
        Luftaustausch. Das Lüften mittels angekippter Fenster reicht nicht aus,
        das Lüften ordnungsgemäß durchzuführen. Zum Treppenhaus hin darf die
        Wohnung nicht entlüftet werden.
      </p>
      <h3 style={{ textAlign: "center" }}>
        <strong>§ 5 Vorsorge bei Abwesenheit</strong>
      </h3>
      <p style={{ textAlign: "justify" }}>
        Bei längerer Abwesenheit ist es erwünscht, den Nachbarn zu verständigen
        und für Notfälle einen erreichbaren Aufbewahrungsort des
        Wohnungsschlüssels zu vereinbaren oder den Schlüssel in einem
        verschlossenen Umschlag beim Hausmeister zu hinterlegen. Während der
        kalten Jahreszeit ist jede Wohnung, auch bei Abwesenheit, ausreichend zu
        beheizen und zu Lüften.
      </p>
      <h3 style={{ textAlign: "center" }}>
        <strong>§ 6 Tierhaltung</strong>
      </h3>
      <p style={{ textAlign: "justify" }}>
        Das Halten von Haustieren, ausgenommen Kleintiere, ist entsprechend des
        Mietvertrages nur nach vorheriger schriftlicher und widerruflicher
        Zustimmung des Vermieters gestattet.
      </p>
      <h3 style={{ textAlign: "center" }}>
        <strong>§ 7 Haus-Außenansicht</strong>
      </h3>
      <p style={{ textAlign: "justify" }}>
        Veränderungen der äußeren Hülle des Hauses durch Markisen, Rollläden,
        Antennen, Satellitenanlagen, Wäscheleinen etc. sind grundsätzlich nicht
        gestattet.
      </p>
      <h3 style={{ textAlign: "center" }}>
        <strong>§ 8 Schadensmeldung</strong>
      </h3>
      <ol>
        <li style={{ textAlign: "justify" }}>
          Nach den gesetzlichen Bestimmungen hat jeder Bewohner zur
          Schadensminderung beizutragen. Im Rahmen der Schadensminderungspflicht
          sind Sofortmaßnahmen einzuleiten, um Schäden am Gebäude, den Bewohnern
          oder Dritten zu mindern sowie für Abhilfe und die Verkehrssicherung
          (Absperrung/Warnzeichen) zu sorgen.
        </li>
        <li style={{ textAlign: "justify" }}>
          Bei Undichtigkeiten oder sonstigen Mängeln an den Gas- und
          Wasserleitungen sind sofort das zuständige Versorgungsunternehmen und
          der Hausmeister oder der Verwalter zu informieren. Wird Gasgeruch in
          einem Raum bemerkt, darf dieser nicht mit offenem Licht betreten
          werden. Elektrische Schalter sind nicht zu betätigen. Die Fenster sind
          zu öffnen, der Hauptabsperrhahn ist sofort zu schließen.
        </li>
        <li style={{ textAlign: "justify" }}>
          Treten Schäden in der Wohnung sowie an Gemeinschaftsanlagen auf, ist
          der Vermieter /Verwalter sofort schriftlich zu verständigen.
        </li>
      </ol>
      <h3 style={{ textAlign: "center" }}>
        <strong>§ 9 Hausmeister</strong>
      </h3>
      <p style={{ textAlign: "justify" }}>
        Der Hausmeister ist der Verwaltung unterstellt. Er wacht im Interesse
        aller Bewohner über die Einhaltung der Hausordnung und ist berechtigt,
        die Hausordnung in geeigneter Weise gegen Bewohner und Gäste
        durchzusetzen. Im Interesse eines harmonischen Zusammenlebens ist den
        Anordnungen des Hausmeisters Folge zu leisten.
      </p>
      <h3 style={{ textAlign: "center" }}>
        <strong>§ 10 Sonstiges</strong>
      </h3>
      <ol>
        <li style={{ textAlign: "justify" }}>
          Jeder Mieter haftet für seine Familienangehörigen, sein Dienstpersonal
          oder für seine Besucher bezüglich der Hausordnung, auch wenn bei
          Zuwiderhandlung kein Verschulden des Mieters selbst vorliegt.
        </li>
        <li style={{ textAlign: "justify" }}>
          Beschwerden über Verstöße gegen die Hausordnung sind dem Vermieter/
          Verwalter schriftlich unter Nennung aller Daten und Fakten zuzuleiten.
          Anonyme Beschwerden lösen keinen Handlungsbedarf aus.
        </li>
        <li style={{ textAlign: "justify" }}>
          Über Ergänzungen und Änderungen der Hausordnung entscheidet der
          Vermieter/ Verwalter.
        </li>
        <li style={{ textAlign: "justify" }}>
          Sollten einige Bestimmungen dieser Hausordnung einer gerichtlichen
          Gültigkeitskontrolle im Einzelfall nicht standhalten, werden ungültige
          Bestimmungen durch sinngemäß gültige ersetzt.
        </li>
      </ol>
    </div>
  );
};

export default VacancyContractHouseRules;
